:host {
  display: flex;
  height: 100%;
}

.grid-item.sc-vx-product-tile {
  height: 100%;
}